import { GetterTree } from 'vuex';
import { GlobalState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<GlobalState, RootState> = {

};
